import React from 'react';
import { Helmet } from 'react-helmet';
import { upperFirst } from 'lodash';

// eslint-disable-next-line react/prop-types
const Header = ({ shopName, service, dateShort, customer }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>Reminder | {shopName}</title>
    </Helmet>
    You have a {upperFirst(service)}
    appointment with {upperFirst(customer.firstName)} {upperFirst(customer.lastName)}&nbsp;
    {dateShort}
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/barber/BarberReminder/components/Header.jsx